<template>
  <main
    id="stock"
    class="page-container stock-index"
    v-if="$route.name === 'listini'"
  >
    <section class="cards-grid-stock">
      <router-link
        v-for="cat in categories"
        :key="cat.slug"
        :to="`/home/listini/${cat.slug}`"
        class="card-stock"
        :aria-label="cat.label"
      >
        <span class="icon-wrap">
          <i :class="cat.icon" aria-hidden="true"></i>
        </span>
        <span class="card-testi">
          <span class="label">{{ cat.label }}</span>
          <!-- [sc-48920] numero di prodotti del listino -->
          <span v-if="conteggi" class="conteggio">{{
            testoConteggioListino(conteggi, cat.slug)
          }}</span>
        </span>
      </router-link>
    </section>
  </main>
  <router-view />
</template>

<script>
import axiosInstance from "@/axiosInstance";
import { testoConteggioListino } from "@/utilities/filtriListino";
import { CATEGORIE } from "@/utilities/categorieArticolo";

export default {
  name: "ListiniPage",
  data() {
    return {
      // { piastrelle: 10717, ... } da item/category-counts; null finché non arriva
      conteggi: null,
      categories: CATEGORIE,
    };
  },
  mounted() {
    this.caricaConteggi();
  },
  watch: {
    // tornando dalle pagine di categoria (articoli aggiunti o archiviati)
    "$route.name"(nome) {
      if (nome === "listini") this.caricaConteggi();
    },
  },
  methods: {
    testoConteggioListino,
    // un errore lascia le card senza conteggio, non blocca la pagina
    async caricaConteggi() {
      try {
        const { data } = await axiosInstance.get("/item/category-counts");
        this.conteggi = data.counts || {};
      } catch {
        this.conteggi = null;
      }
    },
  },
};
</script>

<style src="@/css/StockPage.css" />
<style scoped>
.card-testi {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

/* sotto il titolo, regular 12px */
.conteggio {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
}
</style>
